import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getTournamentGames = createAsyncThunk(
  "getTournamentGames/getTournamentGames",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post("tournament/play-tournament", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const tournamentPlaySlice = createSlice({
  name: "getTournamentGames",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTournamentGames.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTournamentGames.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTournamentGames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default tournamentPlaySlice.reducer;
